import type { ProcessingStatus } from '@/shared/types';

/** The pill on a library card (video or book) for anything not yet ready. */
export const statusLabels: Record<ProcessingStatus, string> = {
  completed: 'Ready',
  processing: 'Rendering',
  queued: 'Queued',
  failed: 'Failed',
  cancelled: 'Cancelled',
  awaiting_confirmation: 'Awaiting confirmation',
  awaiting_reference_review: 'Review characters',
};

export const statusTones: Record<ProcessingStatus, 'green' | 'warn' | 'danger' | 'neutral'> = {
  completed: 'green',
  processing: 'warn',
  queued: 'neutral',
  failed: 'danger',
  cancelled: 'neutral',
  awaiting_confirmation: 'warn',
  awaiting_reference_review: 'warn',
};

/** A book's pill: a video status, or paused waiting for its next chapter to be started. */
export const bookStatusLabels: Record<ProcessingStatus | 'paused', string> = {
  ...statusLabels,
  paused: 'Paused',
};

export const bookStatusTones: Record<ProcessingStatus | 'paused', 'green' | 'warn' | 'danger' | 'neutral'> = {
  ...statusTones,
  paused: 'warn',
};
